import styled from 'styled-components';

export const Courses = styled.article`
  
`;
